import Vue from 'vue';
import Vuex from 'vuex';
import axios from './axios'
import router from './router'

Vue.use(Vuex)

export default new Vuex.Store({
    state:{
        token: null,
        email: null,
        isAdmin: 0,
        workingAsAdmin: 1,
        message:'',
        alert: false,
        alertType: '#1976d2',
        userId: 0,
        newScheduleId: 0,
        timezone: 'UTC',
        logoutMdl: false,
        name: ''
    },
    getters:{
        getName(state){
            return state.name
        },
        getWorkingAs(state){
            return state.workingAsAdmin
        },
        getLogoutMdl(state){
            return state.logoutMdl
        },
        getTimezone(state){
            return state.timezone
        },
        getNewScheduleId(state){
            return state.newScheduleId
        },
        getToken(state){
            return state.token
        },
        getUser(state){
            return state.userId
        },
        getEmail(state){
            return state.email
        },
        getIsAdmin(state){
            return state.isAdmin
        },
        getAlert(state){
            return state.alert
        },
        getAlertMessage(state){
            return state.message
        },
        getAlertType(state){
            return state.alertType
        }
    },
    mutations:{
        setName(state, name){
            state.name = name
        },
        setLogout(state){
            state.logoutMdl = false
        },
        setTimezone(state, timezone){
            state.timezone = timezone
        },
        setNewScheduleId(state,sid){
            state.newScheduleId = sid
        },
        setUserId(state,userId){
            state.userId = userId
        },
        setWorkingAs(state, as){
            state.workingAsAdmin = as
        },
        setToken(state,token){
            state.token = token
        },
        setEmail(state,email){
            state.email = email
        },
        setAdminStatus(state,isAdmin){
            state.isAdmin = isAdmin
        },
        setAlert(state,alert){
            return state.alert = alert
        },
        setAlertType(state,alertType){
            return state.alertType = alertType
        },
        setMessage(state, message){
            return state.message = message
        },
        logout(state){
            state.token = null
            state.email = null
            state.isAdmin = 0
            state.timezone = 'UTC'
            localStorage.removeItem('currentUrl')
            localStorage.clear()
        }
    },
    actions:{
        setEmail({commit}, email){
            commit('setEmail', email)
        },
        setUserName({commit}, name){
            commit('setName', name)
        },
        cancelLogout({commit}){
            commit('setLogout')
        },
        setScheduleId({commit}, sid){
            commit('setNewScheduleId', sid)
        },
        setUser({commit},user){
            commit('setUserId', user)
        },
        setWorkingAs({commit}, as){
            this.commit('setWorkingAs', as)
        },
        setLogoutTimer({commit},exprirationTime){
            setTimeout(()=>{
                commit('logout')
                router.push('/').catch(()=>{})
            }, exprirationTime)
        },
        tryAutoLogin({commit,dispatch}){
            const token = localStorage.getItem('token')
            if(!token){
                localStorage.removeItem('currentUrl')
                dispatch('logout')
                router.push('/').catch(()=>{})
                return
            }
            const expirationDate = localStorage.getItem('expires_in')
            const now = new Date()
            if(now.getTime() > new Date(expirationDate).getTime()){
                localStorage.removeItem('currentUrl')
                dispatch('logout')
                router.push('/').catch(()=>{})
                return
            }
            const expires_in = new Date(expirationDate).getTime()
            const timeoutIn = expires_in - now.getTime()
            dispatch('setLogoutTimer', timeoutIn)

            const email = localStorage.getItem('email')
            const isAdmin = localStorage.getItem('isAdmin')
            const userId = localStorage.getItem('userId')
            const timezone = localStorage.getItem('timezone')
            const name = localStorage.getItem('name')

            commit('setName', name)
            commit('setToken',token)
            commit('setEmail',email)
            commit('setAdminStatus', isAdmin)
            commit('setUserId', userId)
            commit('setTimezone', timezone)
            let url = localStorage.getItem('currentUrl')
            console.log(url)
            router.push(url)
        },
        login({commit,dispatch}, formData){
            axios.post('/login',formData)
            .then(response=>{
                const now = new Date()
                const exprirationDate = new Date(now.getTime() + 3600000)
                localStorage.setItem('token', response.data.access_token)
                localStorage.setItem('email', response.data.email)
                localStorage.setItem('isAdmin', response.data.isAdmin)
                localStorage.setItem('userId', response.data.userId)
                localStorage.setItem('expires_in', exprirationDate)
                localStorage.setItem('timezone', response.data.timezone)
                localStorage.setItem('company', response.data.company)
                localStorage.setItem('dst', response.data.dst)
                localStorage.setItem('loggedInUser', response.data.userId)
                localStorage.setItem('name', response.data.name)

                commit('setName', response.data.name)
                commit('setEmail', response.data.email)
                commit('setAdminStatus', response.data.isAdmin)
                commit('setToken', response.data.access_token)
                commit('setTimezone', response.data.timezone)
                if(parseInt(response.data.isAdmin) == 1){
                    commit('setUserId', response.data.userId)
                    commit('setWorkingAs', 1)
                    router.push('/admin/radios')
                }else if(parseInt(response.data.isAdmin) == 0){
                    router.push('/dashboard/radios')
                }
                dispatch('setLogoutTimer', response.data.expires_in * 1000)
                dispatch('setAlert', 'Welcome back!')
                return true
            })
            .catch(function(error){
                dispatch('setErrorAlert', 'Invalid Login')
            })
        },
        logout({commit}){
            // localStorage.removeItem('token')
            // localStorage.removeItem('email')
            // localStorage.removeItem('isAdmin')
            // localStorage.removeItem('expires_in')
            // localStorage.removeItem('userId')
            // localStorage.removeItem('scheduleId')
            // localStorage.removeItem('timezone')
            // localStorage.removeItem('currentUrl')
            // localStorage.removeItem('name')
            commit('setUserId', 0)
            commit('logout') 
            localStorage.clear()
        },
        setAlert({commit},message){
            commit('setAlertType', '#1976d2')
            commit('setMessage', message)
            commit('setAlert', true)
            setTimeout(()=>{
                commit('setAlert', false)
            },4000)
        },
        setErrorAlert({commit},message){
            commit('setAlertType', '#F0260E')
            commit('setMessage', message)
            commit('setAlert', true)
            setTimeout(()=>{
                commit('setAlert', false)
            },4000)
        },
        register({dispatch,commit},formData){
            axios.post('register',formData)
            .then( response => {
                commit('setAlertType', '#0E89F0')
                dispatch('setAlert', response.data.message)
                dispatch('toLoginPage')
            })
            .catch( error => {
                let message =''
                if(error.response.data.errors.name){
                    message += error.response.data.errors.name[0]
                }
                if(error.response.data.errors.email){
                    message+='\n'+error.response.data.errors.email[0]
                }
                if(error.response.data.errors.password){
                    message+='\n'+ error.response.data.errors.password[0]
                }
                commit('setAlertType', '#F02C0E')
                dispatch('setAlert', message)
            })
        },
        toLoginPage(){
            router.push('/').catch(()=>{})
        },
        setUserTimezone({commit},timezone){
            commit('setTimezone', timezone)
        }
    }
})